import { render } from "./SubtaskCreateView.vue?vue&type=template&id=0ff705d0"
import script from "./SubtaskCreateView.vue?vue&type=script&lang=js"
export * from "./SubtaskCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__